// extracted by mini-css-extract-plugin
module.exports = {"root":"WebshopProductAmount_root__1s1GO","smSize":"WebshopProductAmount_smSize__1908D","mdSize":"WebshopProductAmount_mdSize__290w5"};